<script lang="ts">
  import { store } from '../store.svelte';

  const rows: Array<[string, string]> = [
    ['/', 'Поиск по гримуару'],
    ['?', 'Эта подсказка'],
    ['r', 'Случайный узел'],
    ['g 1–4', 'Карта Nigredo → Rubedo'],
    ['g c', 'Меркуриевы струны'],
    ['g t', 'Наверх'],
    ['j / k', 'Следующая / предыдущая глава'],
    ['→ / ←', 'В раскрытом узле — следующий / предыдущий'],
    ['Esc', 'Закрыть'],
    ['click', 'Любой узел — раскрыть'],
  ];
</script>

<svelte:window onkeydown={(e) => (e.key === 'Escape' ? store.toggleHelp(false) : null)} />

{#if store.helpOpen}
  <button
    class="help-scrim"
    type="button"
    tabindex="-1"
    aria-label="Закрыть подсказку"
    onclick={() => store.toggleHelp(false)}
  ></button>
  <div class="help" role="dialog" aria-modal="true" aria-label="Горячие клавиши">
    <button class="help__x" aria-label="Закрыть" onclick={() => store.toggleHelp(false)}>✕</button>
    <div class="help__t">Горячие клавиши</div>
    <dl>
      {#each rows as [k, v] (k)}
        <div><dt><kbd>{k}</kbd></dt><dd>{v}</dd></div>
      {/each}
    </dl>
  </div>
{/if}

<style>
  .help-scrim {
    position: fixed;
    inset: 0;
    z-index: 70;
    background: rgba(6, 5, 9, 0.7);
    backdrop-filter: blur(5px);
    cursor: pointer;
    padding: 0;
    border: 0;
    appearance: none;
  }
  .help {
    position: fixed;
    z-index: 71;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: min(420px, 92vw);
    background: linear-gradient(165deg, var(--panel), var(--void-2));
    border: 1px solid color-mix(in srgb, var(--mercury) 30%, var(--hair));
    border-radius: 8px;
    padding: 28px 30px 26px;
    box-shadow:
      0 40px 90px -40px #000,
      0 0 60px -30px color-mix(in srgb, var(--mercury) 40%, transparent);
  }
  .help__x {
    position: absolute;
    top: 14px;
    right: 14px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 1px solid var(--hair);
    background: rgba(0, 0, 0, 0.2);
    color: var(--ink-dim);
    cursor: pointer;
    font-size: 1rem;
    line-height: 1;
  }
  .help__x:hover {
    color: var(--ink);
    border-color: var(--mercury);
  }
  .help__t {
    font-family: var(--mono);
    font-size: 0.72rem;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: var(--mercury);
    margin-bottom: 18px;
  }
  dl {
    display: grid;
    gap: 11px;
  }
  dl div {
    display: grid;
    grid-template-columns: 92px 1fr;
    gap: 14px;
    align-items: baseline;
  }
  @media (max-width: 640px) {
    dl div {
      grid-template-columns: 72px 1fr;
      gap: 10px;
    }
    .help {
      padding: 22px 22px 20px;
    }
  }
  dt {
    text-align: right;
  }
  dd {
    color: var(--ink-dim);
    font-size: 0.98rem;
  }
  kbd {
    display: inline-block;
    font-family: var(--mono);
    font-size: 0.72rem;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid var(--hair);
    border-bottom-width: 2px;
    border-radius: 4px;
    padding: 3px 7px;
    color: var(--ink);
    letter-spacing: 0.04em;
    white-space: nowrap;
  }
</style>
